"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.from.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.slice.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/es.regexp.to-string.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/web.timers.js");
var React = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _core = require("../../core");
var _ImgixImg = _interopRequireDefault(require("../../utils/ImgixImg"));
var _UNSAFE_Arrow = require("../UNSAFE_Arrow");
require("./HeaderStyle.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_fkyvd49bh() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Header.tsx";
  var hash = "0a912e228652db9f0763908e5c6d7077dc580c65";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/Header.tsx",
    statementMap: {
      "0": {
        start: {
          line: 35,
          column: 21
        },
        end: {
          line: 148,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 38
        },
        end: {
          line: 36,
          column: 59
        }
      },
      "2": {
        start: {
          line: 38,
          column: 24
        },
        end: {
          line: 38,
          column: 57
        }
      },
      "3": {
        start: {
          line: 39,
          column: 23
        },
        end: {
          line: 39,
          column: 56
        }
      },
      "4": {
        start: {
          line: 42,
          column: 26
        },
        end: {
          line: 42,
          column: 56
        }
      },
      "5": {
        start: {
          line: 44,
          column: 26
        },
        end: {
          line: 50,
          column: 3
        }
      },
      "6": {
        start: {
          line: 46,
          column: 4
        },
        end: {
          line: 46,
          column: 24
        }
      },
      "7": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 49,
          column: 5
        }
      },
      "8": {
        start: {
          line: 48,
          column: 6
        },
        end: {
          line: 48,
          column: 44
        }
      },
      "9": {
        start: {
          line: 52,
          column: 25
        },
        end: {
          line: 58,
          column: 3
        }
      },
      "10": {
        start: {
          line: 55,
          column: 4
        },
        end: {
          line: 57,
          column: 12
        }
      },
      "11": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 56,
          column: 27
        }
      },
      "12": {
        start: {
          line: 60,
          column: 28
        },
        end: {
          line: 63,
          column: 3
        }
      },
      "13": {
        start: {
          line: 62,
          column: 4
        },
        end: {
          line: 62,
          column: 45
        }
      },
      "14": {
        start: {
          line: 62,
          column: 33
        },
        end: {
          line: 62,
          column: 43
        }
      },
      "15": {
        start: {
          line: 65,
          column: 24
        },
        end: {
          line: 78,
          column: 3
        }
      },
      "16": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 69,
          column: 5
        }
      },
      "17": {
        start: {
          line: 68,
          column: 6
        },
        end: {
          line: 68,
          column: 27
        }
      },
      "18": {
        start: {
          line: 72,
          column: 4
        },
        end: {
          line: 77,
          column: 5
        }
      },
      "19": {
        start: {
          line: 73,
          column: 6
        },
        end: {
          line: 73,
          column: 27
        }
      },
      "20": {
        start: {
          line: 74,
          column: 6
        },
        end: {
          line: 76,
          column: 7
        }
      },
      "21": {
        start: {
          line: 75,
          column: 8
        },
        end: {
          line: 75,
          column: 38
        }
      },
      "22": {
        start: {
          line: 80,
          column: 19
        },
        end: {
          line: 80,
          column: 44
        }
      },
      "23": {
        start: {
          line: 81,
          column: 20
        },
        end: {
          line: 81,
          column: 49
        }
      },
      "24": {
        start: {
          line: 83,
          column: 2
        },
        end: {
          line: 147,
          column: 4
        }
      },
      "25": {
        start: {
          line: 152,
          column: 48
        },
        end: {
          line: 156,
          column: 3
        }
      },
      "26": {
        start: {
          line: 158,
          column: 17
        },
        end: {
          line: 164,
          column: 3
        }
      },
      "27": {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 178,
          column: 18
        }
      },
      "28": {
        start: {
          line: 181,
          column: 4
        },
        end: {
          line: 183,
          column: 5
        }
      },
      "29": {
        start: {
          line: 182,
          column: 6
        },
        end: {
          line: 182,
          column: 26
        }
      },
      "30": {
        start: {
          line: 184,
          column: 4
        },
        end: {
          line: 202,
          column: 5
        }
      },
      "31": {
        start: {
          line: 185,
          column: 6
        },
        end: {
          line: 201,
          column: 8
        }
      },
      "32": {
        start: {
          line: 203,
          column: 4
        },
        end: {
          line: 267,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 21
          },
          end: {
            line: 35,
            column: 22
          }
        },
        loc: {
          start: {
            line: 35,
            column: 27
          },
          end: {
            line: 148,
            column: 1
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 44,
            column: 26
          },
          end: {
            line: 44,
            column: 27
          }
        },
        loc: {
          start: {
            line: 44,
            column: 32
          },
          end: {
            line: 50,
            column: 3
          }
        },
        line: 44
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 52,
            column: 25
          },
          end: {
            line: 52,
            column: 26
          }
        },
        loc: {
          start: {
            line: 52,
            column: 31
          },
          end: {
            line: 58,
            column: 3
          }
        },
        line: 52
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 55,
            column: 41
          },
          end: {
            line: 55,
            column: 42
          }
        },
        loc: {
          start: {
            line: 55,
            column: 47
          },
          end: {
            line: 57,
            column: 5
          }
        },
        line: 55
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 60,
            column: 28
          },
          end: {
            line: 60,
            column: 29
          }
        },
        loc: {
          start: {
            line: 60,
            column: 34
          },
          end: {
            line: 63,
            column: 3
          }
        },
        line: 60
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 62,
            column: 18
          },
          end: {
            line: 62,
            column: 19
          }
        },
        loc: {
          start: {
            line: 62,
            column: 33
          },
          end: {
            line: 62,
            column: 43
          }
        },
        line: 62
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 65,
            column: 24
          },
          end: {
            line: 65,
            column: 25
          }
        },
        loc: {
          start: {
            line: 65,
            column: 31
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 65
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 166,
            column: 2
          },
          end: {
            line: 166,
            column: 3
          }
        },
        loc: {
          start: {
            line: 166,
            column: 18
          },
          end: {
            line: 268,
            column: 3
          }
        },
        line: 166
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 47,
            column: 4
          },
          end: {
            line: 49,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 47
      },
      "1": {
        loc: {
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 67,
            column: 4
          },
          end: {
            line: 69,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 67
      },
      "2": {
        loc: {
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 75
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 67,
            column: 8
          },
          end: {
            line: 67,
            column: 23
          }
        }, {
          start: {
            line: 67,
            column: 27
          },
          end: {
            line: 67,
            column: 38
          }
        }, {
          start: {
            line: 67,
            column: 42
          },
          end: {
            line: 67,
            column: 75
          }
        }],
        line: 67
      },
      "3": {
        loc: {
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 72,
            column: 4
          },
          end: {
            line: 77,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 72
      },
      "4": {
        loc: {
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 74,
            column: 6
          },
          end: {
            line: 76,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 74
      },
      "5": {
        loc: {
          start: {
            line: 87,
            column: 45
          },
          end: {
            line: 87,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 87,
            column: 58
          },
          end: {
            line: 87,
            column: 72
          }
        }, {
          start: {
            line: 87,
            column: 75
          },
          end: {
            line: 87,
            column: 77
          }
        }],
        line: 87
      },
      "6": {
        loc: {
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 181,
            column: 4
          },
          end: {
            line: 183,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 181
      },
      "7": {
        loc: {
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 184,
            column: 4
          },
          end: {
            line: 202,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 184
      },
      "8": {
        loc: {
          start: {
            line: 185,
            column: 13
          },
          end: {
            line: 201,
            column: 7
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 191,
            column: 10
          }
        }, {
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 200,
            column: 12
          }
        }],
        line: 185
      },
      "9": {
        loc: {
          start: {
            line: 206,
            column: 20
          },
          end: {
            line: 206,
            column: 52
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 206,
            column: 20
          },
          end: {
            line: 206,
            column: 37
          }
        }, {
          start: {
            line: 206,
            column: 41
          },
          end: {
            line: 206,
            column: 52
          }
        }],
        line: 206
      },
      "10": {
        loc: {
          start: {
            line: 212,
            column: 13
          },
          end: {
            line: 228,
            column: 13
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 213,
            column: 14
          },
          end: {
            line: 225,
            column: 21
          }
        }, {
          start: {
            line: 227,
            column: 14
          },
          end: {
            line: 227,
            column: 18
          }
        }],
        line: 212
      },
      "11": {
        loc: {
          start: {
            line: 231,
            column: 9
          },
          end: {
            line: 257,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 231,
            column: 9
          },
          end: {
            line: 231,
            column: 17
          }
        }, {
          start: {
            line: 232,
            column: 10
          },
          end: {
            line: 256,
            column: 16
          }
        }],
        line: 231
      },
      "12": {
        loc: {
          start: {
            line: 263,
            column: 11
          },
          end: {
            line: 263,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 263,
            column: 11
          },
          end: {
            line: 263,
            column: 28
          }
        }, {
          start: {
            line: 263,
            column: 32
          },
          end: {
            line: 263,
            column: 51
          }
        }],
        line: 263
      },
      "13": {
        loc: {
          start: {
            line: 265,
            column: 9
          },
          end: {
            line: 265,
            column: 37
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 265,
            column: 9
          },
          end: {
            line: 265,
            column: 20
          }
        }, {
          start: {
            line: 265,
            column: 24
          },
          end: {
            line: 265,
            column: 37
          }
        }],
        line: 265
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "0a912e228652db9f0763908e5c6d7077dc580c65"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_fkyvd49bh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_fkyvd49bh();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
cov_fkyvd49bh().s[0]++;
var DropdownMenu = function DropdownMenu() {
  cov_fkyvd49bh().f[0]++;
  var _ref = (cov_fkyvd49bh().s[1]++, React.useState(false)),
    _ref2 = _slicedToArray(_ref, 2),
    isExpanded = _ref2[0],
    setIsExpanded = _ref2[1];
  var triggerButton = (cov_fkyvd49bh().s[2]++, React.useRef());
  var lastMenuItem = (cov_fkyvd49bh().s[3]++, React.useRef());

  // @ts-expect-error Ignoring legacy error since this component is now deprecated
  var mouseOutTimeout = (cov_fkyvd49bh().s[4]++, React.useRef());
  cov_fkyvd49bh().s[5]++;
  var handleMouseOver = function handleMouseOver() {
    cov_fkyvd49bh().f[1]++;
    cov_fkyvd49bh().s[6]++;
    // Show the dropdown menu when a user hovers over the trigger
    setIsExpanded(true);
    cov_fkyvd49bh().s[7]++;
    if (mouseOutTimeout.current) {
      cov_fkyvd49bh().b[0][0]++;
      cov_fkyvd49bh().s[8]++;
      clearTimeout(mouseOutTimeout.current);
    } else {
      cov_fkyvd49bh().b[0][1]++;
    }
  };
  cov_fkyvd49bh().s[9]++;
  var handleMouseOut = function handleMouseOut() {
    cov_fkyvd49bh().f[2]++;
    cov_fkyvd49bh().s[10]++;
    // Hide the dropdown menu when a user hovers away from the trigger and the dropdown menu
    // (The timeout is to accommodate users with less accurate cursor control)
    mouseOutTimeout.current = setTimeout(function () {
      cov_fkyvd49bh().f[3]++;
      cov_fkyvd49bh().s[11]++;
      setIsExpanded(false);
    }, 500);
  };
  cov_fkyvd49bh().s[12]++;
  var handleButtonClick = function handleButtonClick() {
    cov_fkyvd49bh().f[4]++;
    cov_fkyvd49bh().s[13]++;
    // Toggle the dropdown menu when the user clicks on the trigger
    setIsExpanded(function (prevState) {
      cov_fkyvd49bh().f[5]++;
      cov_fkyvd49bh().s[14]++;
      return !prevState;
    });
  };
  cov_fkyvd49bh().s[15]++;
  var handleKeyDown = function handleKeyDown(e) {
    cov_fkyvd49bh().f[6]++;
    cov_fkyvd49bh().s[16]++;
    // Hide the menu when a keyboard user tabs out of it
    if ((cov_fkyvd49bh().b[2][0]++, e.key === 'Tab') && (cov_fkyvd49bh().b[2][1]++, !e.shiftKey) && (cov_fkyvd49bh().b[2][2]++, e.target === lastMenuItem.current)) {
      cov_fkyvd49bh().b[1][0]++;
      cov_fkyvd49bh().s[17]++;
      setIsExpanded(false);
    } else {
      cov_fkyvd49bh().b[1][1]++;
    }

    // Hide the menu and focus back to the menu toggle button on Escape
    cov_fkyvd49bh().s[18]++;
    if (e.key == 'Escape') {
      cov_fkyvd49bh().b[3][0]++;
      cov_fkyvd49bh().s[19]++;
      setIsExpanded(false);
      cov_fkyvd49bh().s[20]++;
      if (triggerButton.current) {
        cov_fkyvd49bh().b[4][0]++;
        cov_fkyvd49bh().s[21]++;
        triggerButton.current.focus();
      } else {
        cov_fkyvd49bh().b[4][1]++;
      }
    } else {
      cov_fkyvd49bh().b[3][1]++;
    }
  };
  var buttonId = (cov_fkyvd49bh().s[22]++, 'primary-nav-submenu-btn');
  var contentId = (cov_fkyvd49bh().s[23]++, 'primary-nav-submenu-content');
  cov_fkyvd49bh().s[24]++;
  return (
    /*#__PURE__*/
    // Handling mouse and key events on the li to maximize size of the hover affordance. Focus/blur keyboard events are handled by the button element.
    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/mouse-events-have-key-events
    React.createElement("li", {
      className: "primary-nav-item dropdown".concat(isExpanded ? (cov_fkyvd49bh().b[5][0]++, ' is-expanded') : (cov_fkyvd49bh().b[5][1]++, ''))
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      ,
      onMouseOver: handleMouseOver
      // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
      ,
      onMouseOut: handleMouseOut,
      onKeyDown: handleKeyDown
    }, /*#__PURE__*/React.createElement(_core.Button, {
      type: "button",
      variant: "link",
      className: "menu-item",
      id: buttonId,
      analyticsName: "header-primary-nav-more",
      "aria-label": "",
      "aria-controls": contentId,
      "aria-expanded": isExpanded,
      onClick: handleButtonClick,
      padding: "0",
      width: "auto",
      height: "auto",
      fontWeight: "normal",
      ref: triggerButton
    }, /*#__PURE__*/React.createElement("span", {
      className: "hidden-xs-down"
    }, "More")), /*#__PURE__*/React.createElement("ul", {
      className: "primary-nav-submenu narrow",
      id: contentId,
      "aria-labelledby": buttonId
    }, /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/about"
    }, "About us")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/stories"
    }, "Stories")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/reviews"
    }, "Reviews")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/faq"
    }, "FAQ")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/jobs"
    }, "Jobs")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/resources"
    }, "Resources")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/blog"
    }, "Blog")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/agents"
    }, "Agents")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/vendor-partnerships"
    }, "Vendors")), /*#__PURE__*/React.createElement("li", {
      className: "primary-nav-submenu-item"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/w/contact-us",
      ref: lastMenuItem
    }, "Contact"))))
  );
};

/** @deprecated */
var Header = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Header, _React$Component);
  function Header() {
    var _this;
    _classCallCheck(this, Header);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Header, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", (cov_fkyvd49bh().s[26]++, {
      isModalOpen: false,
      email: '',
      submitting: false,
      submitted: false,
      submitError: false
    }));
    return _this;
  }
  _createClass(Header, [{
    key: "render",
    value: function render() {
      cov_fkyvd49bh().f[7]++;
      var _ref3 = (cov_fkyvd49bh().s[27]++, this.props),
        analyticsName = _ref3.analyticsName,
        hiddenMobile = _ref3.hiddenMobile,
        hideAccount = _ref3.hideAccount,
        hideNav = _ref3.hideNav,
        hideBorder = _ref3.hideBorder,
        showBrokerageLogo = _ref3.showBrokerageLogo,
        renderAccountMenu = _ref3.renderAccountMenu,
        renderLogo = _ref3.renderLogo,
        renderExtra = _ref3.renderExtra,
        onBackClick = _ref3.onBackClick;
      var logo;
      cov_fkyvd49bh().s[28]++;
      if (renderLogo) {
        cov_fkyvd49bh().b[6][0]++;
        cov_fkyvd49bh().s[29]++;
        logo = renderLogo();
      } else {
        cov_fkyvd49bh().b[6][1]++;
      }
      cov_fkyvd49bh().s[30]++;
      if (!logo) {
        cov_fkyvd49bh().b[7][0]++;
        cov_fkyvd49bh().s[31]++;
        logo = showBrokerageLogo ? (cov_fkyvd49bh().b[8][0]++, /*#__PURE__*/React.createElement(_ImgixImg["default"], {
          className: "opendoor-logo",
          src: "logo-opendoor-homes.svg",
          alt: "Opendoor Homes",
          height: "25"
        })) : (cov_fkyvd49bh().b[8][1]++, /*#__PURE__*/React.createElement("a", {
          href: "/"
        }, /*#__PURE__*/React.createElement("img", {
          className: "opendoor-logo",
          src: "https://imgdrop.imgix.net/logo-opendoor.svg",
          alt: "Opendoor",
          height: "22"
        })));
      } else {
        cov_fkyvd49bh().b[7][1]++;
      }
      cov_fkyvd49bh().s[32]++;
      return /*#__PURE__*/React.createElement("header", {
        className: (0, _classnames["default"])('od-full-header', {
          bordered: (cov_fkyvd49bh().b[9][0]++, showBrokerageLogo) && (cov_fkyvd49bh().b[9][1]++, !hideBorder),
          'hidden-mobile': hiddenMobile
        })
      }, /*#__PURE__*/React.createElement("div", null, onBackClick ? (cov_fkyvd49bh().b[10][0]++, /*#__PURE__*/React.createElement(_core.Link, {
        onClick: onBackClick,
        fontWeight: "bold",
        analyticsName: "".concat(analyticsName, "-back"),
        "aria-label": "Go back to last page."
      }, /*#__PURE__*/React.createElement(_core.Flex, {
        alignItems: "center"
      }, /*#__PURE__*/React.createElement(_core.Box, {
        mr: 2
      }, /*#__PURE__*/React.createElement(_UNSAFE_Arrow.UNSAFE_Arrowhead, {
        rotationDirection: "left",
        size: 4
      })), "Back"))) : (cov_fkyvd49bh().b[10][1]++, logo)), (cov_fkyvd49bh().b[11][0]++, !hideNav) && (cov_fkyvd49bh().b[11][1]++, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
        className: "primary-nav"
      }, /*#__PURE__*/React.createElement("li", {
        className: "primary-nav-item"
      }, /*#__PURE__*/React.createElement("a", {
        className: "menu-item",
        href: "/"
      }, "Sell")), /*#__PURE__*/React.createElement("li", {
        className: "primary-nav-item"
      }, /*#__PURE__*/React.createElement("a", {
        className: "menu-item",
        href: "/w/homes"
      }, "Buy")), /*#__PURE__*/React.createElement("li", {
        className: "primary-nav-item hidden-xs-down"
      }, /*#__PURE__*/React.createElement("a", {
        className: "menu-item",
        href: "/w/how-it-works"
      }, "How it works")), /*#__PURE__*/React.createElement("li", {
        className: "primary-nav-item hidden-xs-down"
      }, /*#__PURE__*/React.createElement("a", {
        className: "menu-item",
        href: "/w/pricing"
      }, "Pricing")), /*#__PURE__*/React.createElement(DropdownMenu, null)))), /*#__PURE__*/React.createElement("div", {
        className: (0, _classnames["default"])('market-header-actions', {
          hidden: hideAccount
        })
      }, (cov_fkyvd49bh().b[12][0]++, renderAccountMenu) && (cov_fkyvd49bh().b[12][1]++, renderAccountMenu())), (cov_fkyvd49bh().b[13][0]++, renderExtra) && (cov_fkyvd49bh().b[13][1]++, renderExtra()));
    }
  }]);
  return Header;
}((React.Component));
_defineProperty(Header, "defaultProps", (cov_fkyvd49bh().s[25]++, {
  hiddenMobile: false,
  hideAccount: false,
  hideNav: false
}));